module.exports = __webpack_public_path__ + "static/img/img_flat@2x.9200511.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_flat@2x.png
// module id = 6yrb
// module chunks = 0